// Copyright ©️ 2026 eVolve MEP, LLC

import { FLAT_BLACK_FILLER } from '@evolvemep/api-ts';

import type { RenderableSpool } from 'components/Autodesk/extensions/SpoolsExtension/types';
import { SpoolAccordion } from 'modules/Shop/Spooling/Assigning/SpoolAccordion';
import { useSpoolAssignment } from 'modules/Shop/Spooling/hooks/useSpoolAssignment';

type Props = {
  disabled: boolean;
  filteredUnassignedSpools: readonly RenderableSpool[];
  colorKeyEnabled: boolean;
};

export const UnassignedSpools = ({ disabled, filteredUnassignedSpools, colorKeyEnabled }: Props) => {
  const {
    unassignedSpoolColorScheme,
    updateUnassignedSpoolColor,
    spoolVisibility,
    selectedSpools,
    onSpoolsSelected,
    setSpoolVisibility,
    loadingAssignedSpools,
    spoolNamesWithFabricationElements,
  } = useSpoolAssignment();

  return (
    <SpoolAccordion
      label="Unassigned Spools"
      itemValue="unassigned"
      loading={loadingAssignedSpools}
      spools={filteredUnassignedSpools}
      getRenderableSpool={(s) => s}
      visibilityProps={{
        disabled,
        getVisibility: (spool) => spoolVisibility[spool.name] ?? false,
        toggle: (spool) => setSpoolVisibility({ visible: !spoolVisibility[spool.name], spoolNames: [spool.name] }),
        toggleAll: (visible: boolean) =>
          setSpoolVisibility({ visible, spoolNames: filteredUnassignedSpools.map((s) => s.name) }),
      }}
      selectionProps={{
        disabled,
        selectedSpools,
        onSpoolsSelected,
      }}
      colorProps={{
        disabled: !colorKeyEnabled,
        getColor: (spool) => unassignedSpoolColorScheme[spool.name] ?? FLAT_BLACK_FILLER,
        updateColor: (spool, newColor) => updateUnassignedSpoolColor(spool.name, newColor),
      }}
      getHasFabricationElements={(spool) => spoolNamesWithFabricationElements.has(spool.name)}
    />
  );
};
